var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button-primary",attrs:{"href":_vm.linkURL}},[_vm._v(_vm._s(_vm.linkText))])
}
var staticRenderFns = []

export { render, staticRenderFns }